export const QA_NAME_APPLICANT_PROFILE_PAGE = 'rentalPortalApplicant'

export const QA_NAME_APPLICANT_PROFILE_LOAD_RETRY = 'applicantProfileRetry'
